import { Client } from 'boardgame.io/react';
import { SpidersGame } from './Game';
import { BoardContainer } from './BoardContainer';

const App = Client({ 
    game: SpidersGame,
    board: BoardContainer
});

export default App;